module.exports = __webpack_public_path__ + "static/media/speaker.4a0dbe85.jpg";